import React from 'react';
import DashboardAdministrator from 'components/dashboard/administrator';
import DashboardSponsor from 'components/dashboard/sponsor';
import DashboardSponsorAdmin from 'components/dashboard/sponsorAdmin';
import DashboardThirdParty from 'components/dashboard/thirdParty';
import DashboardDepartmentReviewer from 'components/dashboard/departmentreviewer';

const Dashboard = ({ appUser }) => {
  const { role } = appUser;
  return (
    <>
      {
        {
          ADMINISTRATOR: <DashboardAdministrator appUser={appUser} />,
          SPONSOR: <DashboardSponsor appUser={appUser} />,
          LIMITED_ADMINISTRATOR: <DashboardSponsorAdmin appUser={appUser} />,
          DEPARTMENT_REVIEWER: <DashboardDepartmentReviewer appUser={appUser} />,
          THIRD_PARTY: <DashboardThirdParty appUser={appUser} />,
        }[role]
      }
    </>
  );
};

export default Dashboard;
